import Container from "./Container";

const PolicyContentInput: React.FC<any> = ({ value, onChange }) => {
  return (
    <div className="bg-gray-600 p-4 rounded-md">
      <Container {...{ value, onChanged: onChange, canDelete: false }} />
    </div>
  );
};

export default PolicyContentInput;
